export const inputProps = {
  props: {
    fieldProperties: { required: true,
      type: Object,
      default () {
        return {}
      } },
    value: { required: true, default: null },
    canSave: { type: Boolean, default: true }
  },
  mounted: function () {},
  methods: {
    emitChange: function (value) {
      this.$emit('input', value.value)
    }
  }
}
